import React from "react";

import { Grid, GridSize } from "@mui/material";

import FieldView, { FieldViewProps } from "../../../Form/FieldView";
import SkeletonComponent from "../../Skeleton";
import useStyles, { SectionViewContainer, ViewSectionTitle } from "./styles";

interface GridSizeProps {
  sm?: GridSize;
  md?: GridSize;
}
export interface FieldViewWithGridProps extends FieldViewProps, GridSizeProps { }
interface ViewSectionProps extends GridSizeProps {
  fields: FieldViewWithGridProps[][];
  title?: string;
  loading?: boolean;
  index?: number;
  noPadding?: boolean;
}

export const SectionView = ({
  fields,
  title,
  sm: sectionSM = 12,
  md: sectionMD = 3,
  loading = false,
  index,
  noPadding = false,
}: ViewSectionProps) => {
  const classes = useStyles();

  return (
    <SectionViewContainer noPadding={noPadding} hasTitle={!!title}>
      {title ? (
        <ViewSectionTitle className="viewSectionTitle" isFirstItem={index === 0}>
          {title}
        </ViewSectionTitle>
      ) : null}
      <SkeletonComponent isLoading={loading}>
        <Grid container item spacing={3}>
          {fields.map((row, index) => {
            return (
              <Grid key={`row-${index}`} container item spacing={3}>
                {row.map((field, index) => {
                  const { sm = sectionSM, md = sectionMD } = field;

                  return (
                    <Grid key={field?.label ?? index} sm={sm} md={md} item>
                      <FieldView
                        labelClass={classes.label}
                        valueClass={classes.valueLabel}
                        {...field}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </Grid>
      </SkeletonComponent>
    </SectionViewContainer>
  );
};
